module.exports = __webpack_public_path__ + "img/galerie_preview-600x450.9f767818.jpg";